import { getWeek, getWeeksInMonth, isSameDay, isSameMonth, setDate, setDay, setWeek } from 'date-fns';
export var getPartialWeeks = _ref => {
  var {
    activeMonth,
    secondarySelectedDate,
    selectedDate,
    isBeforeMinDate,
    isAfterMaxDate,
    isHoliday,
    isInWeekDays
  } = _ref;
  var dayInMonth = setDate(activeMonth.date, 1);
  var numWeeks = getWeeksInMonth(dayInMonth);
  var weeks = [];
  var diff = getWeek(dayInMonth);

  for (var i = 0; i < numWeeks; i++) {
    if (!weeks[i]) weeks[i] = [];
    var week = weeks[i];
    var weekDay = setWeek(dayInMonth, diff + i);

    for (var j = 0; j < 7; j++) {
      var day = setDay(weekDay, j);

      if (isSameMonth(dayInMonth, day)) {
        week.push({
          isDisabled: isBeforeMinDate(day) || !isInWeekDays(day) || isHoliday(day) || isAfterMaxDate(day),
          isSecondarySelectedDate: !!secondarySelectedDate && isSameDay(secondarySelectedDate, day),
          isSelected: !!selectedDate && isSameDay(selectedDate, day),
          date: day
        });
      } else {
        week.push(null);
      }
    }
  }

  return weeks;
};
//# sourceMappingURL=getPartialWeeks.js.map